import { render, staticRenderFns } from "./DailyMenuSelectionCard.vue?vue&type=template&id=b9c23b72&scoped=true"
import script from "./DailyMenuSelectionCard.vue?vue&type=script&lang=js"
export * from "./DailyMenuSelectionCard.vue?vue&type=script&lang=js"
import style0 from "./DailyMenuSelectionCard.vue?vue&type=style&index=0&id=b9c23b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c23b72",
  null
  
)

export default component.exports